'use client';

import React from 'react';
import useLocale from '$hooks/use-locale';
import { COMMON } from '$ops-portal/locale/constants';
import { Button, Modal } from '@brahma/components';
import { ButtonType } from '@dfg/brahma-types';
import styles from './reportRegenerationModal.module.scss';
import useGlobalContext from '$ops-portal/hooks/use-global-context';
import { ContextAction } from '$ops-portal/context/global-context/types';
const ReportRegenerationModal = () => {
  const {
    t
  } = useLocale([COMMON]);
  const {
    state,
    dispatch
  } = useGlobalContext();
  const onCloseClick = () => {
    dispatch({
      type: ContextAction.setReportRegenerationModal,
      payload: false
    });
  };
  return <Modal show={state.isReportRegenerationModalOpen} openDirection="center" onBackdropClick={onCloseClick} data-sentry-element="Modal" data-sentry-component="ReportRegenerationModal" data-sentry-source-file="reportRegenerationModal.tsx">
      <div className={styles.modalBodyMain}>
        <div className={styles.headingContainer}>
          <div className={styles.heading}>
            {t('reportRegenerationModal.title')}
          </div>
        </div>
        <div className={styles.regenerateReportContainer}>
          <div>
            <div className={styles.regenerateReportInfoContainer}>
              <div className={styles.regenerateReportInfoNote}>
                {t('reportRegenerationModal.note')}
              </div>
              <div className={styles.regenerateReportInfoInformation}>
                {t('reportRegenerationModal.information')}
              </div>
            </div>
            <div className={styles.regenerateReportDescription}>
              {t('reportRegenerationModal.description')}
            </div>
            <div className={styles.okayButtonContainer}>
              <Button text={t('reportRegenerationModal.okay')} onClick={onCloseClick} variant={ButtonType.Primary} className={styles.okayButton} data-sentry-element="Button" data-sentry-source-file="reportRegenerationModal.tsx" />
            </div>
          </div>
        </div>
      </div>
    </Modal>;
};
export default ReportRegenerationModal;